import React from "react";
import Link from "react-router-dom/Link.js";

const QuickLinks = () => {
  const quickLinks = [
    {
      href: "/galerie-photos",
      text: "Galerie Photos ONPR",
      icon: "pi-file",
    },
    {
      href: "/calendrier-evenements",
      text: "Calendrier des Événements et brèves",
      icon: "pi-file",
    },
    {
      href: "/declaration-accident",
      text: "Déclaration d'accident",
      icon: "pi-file",
    },
  ];

  return (
    <div className="quick-links-card">
      <h3>
        <i className="pi pi-bookmark"></i> Liens Rapides
      </h3>
      {quickLinks.map((link, index) => (
        <Link key={index} to={link.href} className="quick-link">
          <i className={`pi ${link.icon}`}></i> {link.text}
        </Link>
      ))}
    </div>
  );
};

export default QuickLinks;
